// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3TGvV","content":"ManualTimeModal_content__1YgBK"};